import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p40: pxToRem(40),
};

export const OverviewTabWrapper = styled.div`
  display: grid;
  gap: ${customSpacing.p40} ${spacing.double};
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas:
    'Goal-Performance Goal-Performance'
    'Completion-Vs-Sends Goal-Contributions-By-Medium'
    'Campaign-Performance Campaign-Performance';
`;

export const GoalPerformanceWrapper = styled.div`
  grid-area: Goal-Performance;
`;

export const CompletionVsSendsWrapper = styled.div`
  grid-area: Completion-Vs-Sends;
`;

export const GoalContributionsByMediumWrapper = styled.div`
  grid-area: Goal-Contributions-By-Medium;
`;

export const CampaignPerformanceWrapper = styled.div`
  grid-area: Campaign-Performance;
`;

export const CampaignTabWrapper = styled.div`
  display: grid;
  gap: ${customSpacing.p40} ${spacing.double};
  grid-template-areas: 'Campaign-Contribution';
`;

export const CampaignContributionWrapper = styled.div`
  grid-area: Campaign-Contribution;
`;
